export const TOGGLE_ALL_SHADES = 'BEAMLY/CCX/TOGGLE_ALL_SHADES';
